import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterSortColumnsLogic} from "./FilterSortColumns.logic";
import {
  IRadioButtonFilterGroupOptionItem,
  RadioButtonFilterGroup
} from "../../filters/radio-button-filter-group/RadioButtonFilterGroup";
import {MySongsPageSortColumnType, mySongsPageSortOptionsConfig} from "../../../config/my-songs-page-sort";

const filterSortColumnsOptions = mySongsPageSortOptionsConfig
  .map<IRadioButtonFilterGroupOptionItem<MySongsPageSortColumnType>>(({column, display: {title}}) => ({label: title, value: column,}));

export const FilterSortColumns: VoidFunctionComponent = () => {
  const {value, onChangeHandler} = useFilterSortColumnsLogic();
  return <RadioButtonFilterGroup<MySongsPageSortColumnType>
    value={value}
    onChange={onChangeHandler}
    options={filterSortColumnsOptions}
  />;
}
